import Loading from './Loading';

export default Loading;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Loading/index.js